/** Set while user is typing in search from a page that navigates to home (Header remounts). */
export const SEARCH_INPUT_FOCUS_KEY = 'raheasy_search_input_focus';

export function markSearchInputFocusPending() {
  try {
    sessionStorage.setItem(SEARCH_INPUT_FOCUS_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function consumeSearchInputFocusPending() {
  try {
    const pending = sessionStorage.getItem(SEARCH_INPUT_FOCUS_KEY) === '1';
    if (pending) sessionStorage.removeItem(SEARCH_INPUT_FOCUS_KEY);
    return pending;
  } catch {
    return false;
  }
}

export function clearSearchInputFocusPending() {
  try {
    sessionStorage.removeItem(SEARCH_INPUT_FOCUS_KEY);
  } catch {
    /* ignore */
  }
}
